import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { ApiService } from './api.service';
import { CARD_MEDIA_PARAMS } from './property.service';

/**
 * Page Group Service
 *
 * @export
 * @class Global
 */
@Injectable({ providedIn: 'root' })
export class BlogService {
    constructor(private apiService: ApiService) {}

    /**
     * get all blogs
     * @returns
     */
    getAllBlogs(params?: Object) {
        return this.apiService.get('api/v1/blogs', params);
    }

    /**
     * get one blog
     * @returns
     */
    getOneBlog(slug: string, params?: Object) {
        return this.apiService.get(`api/v1/blogs/${slug}`, params);
    }

    /**
     * get related blogs
     * @returns
     */
    getRelatedBlogs(slug: string, params?: Object) {
        return this.apiService.get(`api/v1/blogs/${slug}/related-blogs`, params);
    }

    /**
     * get recent blogs
     * @returns
     */
    getRecentBlogs(options: any) {
        const params: any = {};
        params['page'] = get(options, 'page', 1);
        params['per_page'] = get(options, 'no_of_posts', 5);
        if (options.post_by === 'tag') {
            params['tag'] = options.tag;
        }
        if (options.post_by === 'category') {
            params['category'] = options.category;
        }
        params['sort_field'] = 'posted_at';
        params['sort_by'] = 'desc';
        return this.apiService.get('api/v1/blogs', params);
    }

    getBlogCategory(url: string) {
        return this.apiService.get(`api/v1/blogs/category/${url}`);
    }

    /**
     * Get blogs by category
     * @param params
     * @returns
     */
    getBlogsByCategory(params?: any) {
        return this.apiService.get('api/v1/blogs/by-category', params);
    }

    /**
     * Get blogs by month
     * @param params
     * @returns
     */
    getBlogsByMonth(params?: any) {
        return this.apiService.get('api/v1/blogs/by-month', params);
    }

    getFeaturedBlog(params?: {}) {
        return this.apiService.get('api/v1/blogs/featured-blogs', params);
    }

    /**
     * To fetch blogs by city name in title for use in property detail page
     * @param city
     * @param params
     * @returns
     */
    getBlogsByCity(city: string, params?: {}) {
        return this.apiService.get(`api/v1/blogs/by-city/${city}`, params);
    }

    /**
     * To fetch properties related to blog title
     * @param params 
     * @returns 
     */
    getRelatedProperties(params: Record<string, any> = {}) {
        return this.apiService.get('api/v2/blogs/related-properties', { ...CARD_MEDIA_PARAMS, ...params });
    }
}
